import { Helmet } from "react-helmet-async";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export interface FAQItem {
  q: string;
  a: string;
}

interface FAQProps {
  title?: string;
  subtitle?: string;
  items: FAQItem[];
  /** Quando true, NÃO injeta JSON-LD (use se o schema já vem de outro componente, p.ex. HomeStructuredData) */
  noSchema?: boolean;
}

const FAQ = ({
  title = "Perguntas frequentes",
  subtitle = "Tire suas principais dúvidas sobre nossos atendimentos.",
  items,
  noSchema = false,
}: FAQProps) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((it) => ({
      "@type": "Question",
      name: it.q,
      acceptedAnswer: { "@type": "Answer", text: it.a },
    })),
  };

  return (
    <section aria-labelledby="faq-heading" className="py-16 md:py-24 bg-background">
      {!noSchema && (
        <Helmet>
          <script type="application/ld+json">{JSON.stringify(schema)}</script>
        </Helmet>
      )}
      <div className="container mx-auto px-4 max-w-3xl">
        <div className="text-center mb-10">
          <h2 id="faq-heading" className="font-heading text-3xl md:text-4xl font-bold text-foreground mb-3">
            {title}
          </h2>
          <p className="text-muted-foreground">{subtitle}</p>
        </div>
        <Accordion type="single" collapsible className="w-full">
          {items.map((it, i) => (
            <AccordionItem key={i} value={`item-${i}`}>
              <AccordionTrigger className="text-left font-heading font-semibold text-base md:text-lg">
                {it.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed">
                {it.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
